import { render, staticRenderFns } from "./CreateEstimates.vue?vue&type=template&id=cc677984&scoped=true&"
import script from "./CreateEstimates.vue?vue&type=script&lang=js&"
export * from "./CreateEstimates.vue?vue&type=script&lang=js&"
import style0 from "./CreateEstimates.vue?vue&type=style&index=0&id=cc677984&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc677984",
  null
  
)

export default component.exports